import React from 'react';
import CellAbstract from './CellAbstract';
import { ProgressBar } from '@progress/kendo-react-progressbars';
import { isFunction, isNumber } from 'lodash';
import { CELL_PROGRESS_PROPS } from './Types';

class CellProgress extends CellAbstract<CELL_PROGRESS_PROPS, {}> {
  render() {
    const {
      cellConfig = {},
      dataItem,
      dataIndex,
      field
    } = this.props;
    const { convert } = cellConfig;
    const value = dataItem[(field || dataIndex)];
    const progress = isFunction(convert) ? convert(value, dataItem) : value;

    const cmp = isNumber(progress)
      ? (
        <>
          <ProgressBar
            className="tp-progress-grid-cell"
            labelVisible={false}
            value={progress}
            tabIndex={-1}
          />
          <span
            className='tp-font-size-sm tp-space-left-half-1 tp-text-regular'
          >{`${progress}%`}</span>
        </>
      )
      : (
        <div>{progress}</div>
      );

    return this.renderCell(cmp);
  }
}

export default CellProgress;
